module.exports = __webpack_public_path__ + "media/public/images/about/experts/center_benua-d75065df3173cf4201d18b1f54803961.svg";